module.exports = __webpack_public_path__ + "static/pid-ug-5-en-confirmsigncode-44fd07623cd13eb1e6ae5b4aea4c8462.png";